"use client";
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NavItems } from "../../utility/Navigation";
import Onex from "./Onex";
import Qpms from "./Qpms";
import Secure from "./Secure";
import Onmark from "./Onmark";
import EnglishLab from "./EnglishLab";
import EzyTest from "./EzyTest";
import Digitab from "./Digitab";
import Digilab from "./Digilab";
import { useParams, useNavigate } from "react-router-dom";
import Exam from "./Exam";
import ExamSurveillance from "./ExamSurveliance";

const Solution = () => {
  const { solutionId } = useParams();
  const navigate = useNavigate();

  const solutionTabs = NavItems.find(
    (item) => item.name === "Our Solutions"
  ).items;

  const handleTabClick = (key) => {
    if (key === solutionId) {
      navigate("/oursolutions");
    } else {
      navigate(`/oursolutions/${key}`);
    }
  };

  const renderSolution = () => {
    switch (solutionId) {
      case "onex":
        return <Onex />;
      case "qpms":
        return <Qpms />;
      // case "secure":
      //   return <Secure />;
      case "onmark":
        return <Onmark />;
      case "englishlab":
        return <EnglishLab />;
      case "ezytest":
        return <EzyTest />;
      case "digitab":
        return <Digitab />;
      case "digitlab":
        return <Digilab />;
      case "ExamSurveillance":
        return <ExamSurveillance />;
      default:
        return (
          <>
            <Onex />
            <Qpms />
            <Secure />
            <Onmark />
            <EnglishLab />
            <EzyTest />
            <Digitab />
            <Digilab />
            <ExamSurveillance />
          </>
        );
    }
  };

  return (
    <div className="heade ">
      {/* Sticky Header Tabs */}
      <div
        className="sticky-top bg-white shadow-sm z-3 tophead"
        style={{ top: "70px" }}
      >
        <div className="d-flex overflow-auto p-2 mt-70 justify-content-start justify-content-md-center">
          <div className="d-flex flex-nowrap gap-2 gap-sm-3">
            {solutionTabs.map((tab) => (
              <motion.button
                key={tab.key}
                onClick={() => handleTabClick(tab.key)}
                whileHover={{ scale: 1.05 }}
                className={`border d-flex align-items-center gap-1 gap-sm-2 flex-shrink-0 position-relative ${
                  solutionId === tab.key
                    ? "btn-primary text-white"
                    : "btn-outline-secondary text-dark"
                }`}
                style={{
                  minWidth: "fit-content",
                  padding: "8px 12px",
                }}
              >
                <img
                  src={tab.image}
                  className="solutionImage"
                  style={{
                    height: "40px",
                    width: "140px",
                    objectFit: "contain",
                  }}
                />

                {/* Active Indicator */}
                <AnimatePresence>
                  {solutionId === tab.key && (
                    <motion.span
                      layoutId="tab-active"
                      className="position-absolute bottom-0 start-0 end-0 bg-primary"
                      style={{ height: "3px" }}
                      initial={{ opacity: 0, width: 0 }}
                      animate={{ opacity: 1, width: "100%" }}
                      exit={{ opacity: 0, width: 0 }}
                      transition={{
                        type: "spring",
                        stiffness: 500,
                        damping: 30,
                      }}
                    />
                  )}
                </AnimatePresence>
              </motion.button>
            ))}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {renderSolution()}
      </motion.div>
    </div>
  );
};

export default Solution;
